module.exports = __webpack_public_path__ + "img/laprecision-logo-meta.c2d297b7.jpg";